import React from "react";
import { siteData } from "../mock";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-col">
          <p className="footer-brand">{siteData.brand.name}</p>
          <p className="footer-copy">
            © {new Date().getFullYear()} Catherine SAC-EPEE — Praticienne en Shiatsu
          </p>
        </div>
        <div className="footer-col footer-links">
          <a href={siteData.contact.phoneHref}>{siteData.contact.phone}</a>
          <span className="dot">·</span>
          <a href={`mailto:${siteData.contact.email}`}>{siteData.contact.email}</a>
          <span className="dot">·</span>
          <a href="#">mentions légales</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
